export default __webpack_public_path__ + "static/media/seaWater.13f66cf7.jpeg";